import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { PERFECT_SCROLLBAR_CONFIG } from "ngx-perfect-scrollbar";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoginComponent } from './security/login/login.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { DashboardComponent } from './component/dashboard/dashboard.component';
import { CallingListComponent } from './component/calling-list/calling-list.component';
import { HeaderComponent } from './layout/component/header/header.component';
import { CallingDialogComponent } from './modal/calling-dialog/calling-dialog.component';
import { Customer360Component } from './component/customer360/customer360.component';
import { CommonService } from './core/service/common-service/common.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { ToastrModule } from 'ngx-toastr';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { ReminderDialogComponent } from './modal/reminder-dialog/reminder-dialog.component';
import { DatePipe } from '@angular/common';
import { DigitsOnlyDirective } from './directive/digits-only.directive';
import { AlphabetOnlyDirective } from './directive/char-only.directive';
import { MAT_DATE_LOCALE, MAT_DATE_FORMATS, DateAdapter } from '@angular/material';
import { MomentUtcDateAdapter } from './pipes/moment-utc-date-adapter';
import { MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import { FilterPipePipe } from './pipes/filter-pipe.pipe';
import { MaterialModule } from './shared/material.module';
import { MainLayoutComponent } from './layout/component/main-layout/main-layout.component';
import { AuthService } from './core/authentication/authentication.service';
import { AuthGuardService } from './core/authentication/authentication.guard';
import { FlexLayoutModule } from "@angular/flex-layout";
import { TruncatePipe } from './pipes/truncate.pipe';
import { SafePipe } from './pipes/safe.pipe';
import { InboundCallComponent } from './component/inbound-call/inbound-call.component';
import { UserService } from './core/service/user-service/user.service';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { Customer360DialogComponent } from './modal/customer360-dialog/customer360-dialog.component';
import { ProfileComponent } from './component/profile/profile.component';
import { BasicAuthInterceptor } from './core/service/http-interceptor/auth-interceptor';
import { ErrorInterceptor } from './core/service/http-interceptor/error-interceptor';
import { ReportingComponent } from './component/reporting/reporting.component';
import { RecordingDialogComponent } from './modal/recording-dialog/recording-dialog.component';
import { CustomToolTipComponent } from './directive/custom-tool-tip/custom-tool-tip.directive';
import { ToolTipRendererDirective } from './directive/custom-tool-tip/tool-tip-renderer.directive';
import { UamComponent } from './component/uam/uam.component';
import { ServicenotrequireDailogComponent } from './modal/servicenotrequire-dailog/servicenotrequire-dailog.component';
import { ChartsModule } from 'ng2-charts';
import { ChartDashboardComponent } from './component/dashboard/chart-dashboard/chart-dashboard.component';
import { ChartDialogComponent } from './modal/chart-dialog/chart-dialog.component';
import { ServiceBreakDialogComponent } from './modal/service-break-dialog/service-break-dialog.component';
import { ExampleHeader } from './component/dashboard/custom-header-cal/custom-header.component';
import { PrsCallingListComponent } from './component/prs-calling-list/prs-calling-list.component';
import { PrsCustomer360Component } from './component/prs-customer360/prs-customer360.component';
import { PrsReportingComponent } from './component/prs-reporting/prs-reporting.component';
import { BarRatingModule } from "ngx-bar-rating";
import { SoftOfferingsComponent } from './component/soft-offerings/soft-offerings.component';
import { SoftOfferingReportingComponent } from './component/soft-offering-reporting/soft-offering-reporting.component';
import { SoftCustomer360Component } from './component/soft-customer360/soft-customer360.component';
import { SoftCallingDialogComponent } from './modal/soft-calling-dialog/soft-calling-dialog.component';
import { MarketShareReportingComponent } from './component/market-share-reporting/market-share-reporting.component';
import { BlanketFeedbackDailogComponent } from './modal/blanket-feedback-dailog/blanket-feedback-dailog.component';
import { CdmCallingListComponent } from './component/cdm-calling-list/cdm-calling-list.component';
import { CdmCustomer360Component } from './component/cdm-customer360/cdm-customer360.component';
import { NewTicketDialogComponent } from './modal/new-ticket-dialog/new-ticket-dialog.component';
import { ForgotPasswordDialogComponent } from './security/forgot-password-dialog/forgot-password-dialog.component';
import { LostCustomerComponent } from './component/lost-customer/lost-customer.component';
import { LostCustomer360Component } from './component/lost-customer360/lost-customer360.component';
import { LostCallingDialogComponent } from './modal/lost-calling-dialog/lost-calling-dialog.component';
import { VisitReportComponent } from './modal/visit-report/visit-report.component';
import { WorkshopManagerCallingListComponent } from './component/workshop-manager-calling-list/workshop-manager-calling-list.component';
import { LostCustomerLeadUpdateDialogComponent } from './modal/lost-customer-lead-update-dialog/lost-customer-lead-update-dialog.component';
import { PrsComplaintDialogComponent } from './modal/prs-complaint-dialog/prs-complaint-dialog.component';
import { PrsDashboardComponent } from './component/prs-dashboard/prs-dashboard.component';
import { ChartPrsDashboardComponent } from './component/prs-dashboard/chart-prs-dashboard/chart-prs-dashboard.component';
import {WorkshopReassignmentComponent} from './component/workshop-reassignment/workshop-reassignment.component';
import {WorkshopReassignmentDialogComponent} from './modal/workshop-reassignment-dialog/workshop-reassignment-dialog.component';
import {PipelineManagementComponent} from './component/pipeline-management/pipeline-management.component';
import {PipelineSearchComponent} from './component/pipeline-search/pipeline-search.component';
import {PipelineEnquiryComponent} from './modal/pipeline-enquiry/pipeline-enquiry.component';
import {PipelineEnquiryTableComponent} from './modal/pipeline-enquiry-table/pipeline-enquiry-table.component';
import {LeadStatusDialogComponent} from './modal/lead-status-dialog/lead-status-dialog.component';
import { DoorstepCallingListComponent } from './component/doorstep-calling-list/doorstep-calling-list.component';
import { DoorstepCustomer360Component } from './component/doorstep-customer360/doorstep-customer360.component';
import { DoorstepCallingDialogComponent } from './modal/doorstep-calling-dialog/doorstep-calling-dialog.component';
import { DoorstepDashboardComponent } from './component/doorstep-dashboard/doorstep-dashboard.component';
import { DoorstepChartDashboardComponent } from './component/doorstep-dashboard/doorstep-chart-dashboard/doorstep-chart-dashboard.component';
import { AdminComponent} from './component/admin/admin.component';
import { MatDialogModule, MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ConfirmDialogComponent } from './modal/confirm-dialog/confirm-dialog.component';
import { DialogService } from './dialog.service';
import { TitanDealerDashboardComponent } from './component/titan-dealer-dashboard/titan-dealer-dashboard.component';
import { UpdatePhoneNumberDialogComponent } from './modal/update-phone-number-dialog/update-phone-number-dialog.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DashboardComponent,
    ReportingComponent,
    CallingListComponent,
    HeaderComponent,
    CallingDialogComponent,
    RecordingDialogComponent,
    Customer360Component,
    InboundCallComponent,
    ReminderDialogComponent,
    Customer360DialogComponent,
    ProfileComponent,
    DigitsOnlyDirective,
    AlphabetOnlyDirective,
    FilterPipePipe,
    MainLayoutComponent,
    TruncatePipe,
    SafePipe,
    CustomToolTipComponent,
    ToolTipRendererDirective,
    UamComponent,
    ServicenotrequireDailogComponent,
    ChartDashboardComponent,
    ChartDialogComponent,
    ServiceBreakDialogComponent,
    ExampleHeader,
    PrsCallingListComponent,
    PrsCustomer360Component,
    PrsReportingComponent,
    SoftOfferingsComponent,
    SoftOfferingReportingComponent,
    SoftCustomer360Component,
    SoftCallingDialogComponent,
    MarketShareReportingComponent,
    BlanketFeedbackDailogComponent,
    CdmCallingListComponent,
    CdmCustomer360Component,
    NewTicketDialogComponent,
    ForgotPasswordDialogComponent,
    LostCustomerComponent,
    LostCustomer360Component,
    LostCallingDialogComponent,
    VisitReportComponent,
    WorkshopReassignmentComponent,
    WorkshopReassignmentDialogComponent,
    PrsComplaintDialogComponent,
    PrsDashboardComponent,
    ChartPrsDashboardComponent,
    WorkshopManagerCallingListComponent,
    LostCustomerLeadUpdateDialogComponent,
    PipelineSearchComponent,
    PipelineManagementComponent,
    PipelineEnquiryComponent,
    LeadStatusDialogComponent,
    PipelineEnquiryTableComponent,
    DoorstepCallingListComponent,
    DoorstepCustomer360Component,
    DoorstepCallingDialogComponent,
    DoorstepDashboardComponent,
    DoorstepChartDashboardComponent,
    AdminComponent,
    ConfirmDialogComponent,
    TitanDealerDashboardComponent,
    UpdatePhoneNumberDialogComponent,
    
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    HttpClientModule,
    NgxMaterialTimepickerModule,
    PerfectScrollbarModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: false,
      progressBar: false,
      progressAnimation: "increasing"
    }),
    ReactiveFormsModule,
    FormsModule,
    AngularFontAwesomeModule,
    FlexLayoutModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    ChartsModule,
    BarRatingModule,
    MatDialogModule,
    MatIconModule,
    SlickCarouselModule
  ],
  exports: [HeaderComponent],
  providers: [CommonService, AuthService, AuthGuardService, UserService, DatePipe,DialogService,
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    { provide: DateAdapter, useClass: MomentUtcDateAdapter },
    { provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG },
    { provide: HTTP_INTERCEPTORS, useClass: BasicAuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    {provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: {hasBackdrop: true}}
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    CustomToolTipComponent,
    CallingDialogComponent,
    ReminderDialogComponent,
    Customer360DialogComponent,
    ChartDialogComponent,
    ServiceBreakDialogComponent,
    ServicenotrequireDailogComponent,
    ExampleHeader,
    SoftCallingDialogComponent,
    BlanketFeedbackDailogComponent,
    NewTicketDialogComponent,
    ForgotPasswordDialogComponent,
    LostCallingDialogComponent,
    VisitReportComponent,
    LostCustomerLeadUpdateDialogComponent,
    PrsComplaintDialogComponent,
    WorkshopReassignmentDialogComponent,
    PipelineEnquiryComponent,
    LeadStatusDialogComponent,
    PipelineEnquiryTableComponent,
    DoorstepCallingDialogComponent,
    ConfirmDialogComponent,
    UpdatePhoneNumberDialogComponent

 ]
})
export class AppModule { }